<template>
    <v-container style="padding-top: 80px">
        <v-card>
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">Días Vacaciones</span>
            </v-card-title>
            <v-card-text v-if="cargandoDias">
                <v-container style="height: 400px;">
                    <v-row class="fill-height" align-content="center" justify="center">
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Cargando días de vacaciones
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-text v-else>
                <v-row justify="center">
                    <v-col cols="12" md="9">
                        <v-row class="mt-2">
                            <v-col cols="12" md="6">
                                <span style="font-weight: bold;">Fecha Ingreso: </span>
                                <span style="font-weight: bold; font-size: larger;" class="ml-1"> {{ datos.usalta
                                    }}</span>
                            </v-col>
                            <v-col cols="12" md="6" class="plazodias">
                                <span style="font-weight: bold;">Días restantes para solicitar vacaciones : </span>
                                <span style="font-weight: bold; font-size: larger;" class="ml-1"
                                    :style="{ color: datos.colorplazodias }"> {{ datos.diasplazo }}
                                    días </span>
                            </v-col>
                        </v-row>
                        <br>
                        <v-divider></v-divider>
                        <v-row v-if="mostrarperiodoant" class="mt-2 mx-1">
                            <v-row class="mt-4">
                                <v-col cols="12" md="3">
                                    <v-card color="rgba(103, 164, 193, 0.14)">
                                        <v-card-text style="display: grid; place-items: center;">
                                            <div>
                                                <span>Días Totales:</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1" style="font-size: medium; font-weight: bold;">{{
                                                    datosperiodoAnt.vdias }}</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1">{{ datosperiodoAnt.vacperiodo }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-card color="rgba(103, 164, 193, 0.14)">
                                        <v-card-text style="display: grid; place-items: center;">
                                            <div>
                                                <span>Días Caducados:</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1" style="font-size: medium; font-weight: bold;">{{
                                                    datosperiodoAnt.vacdisponibles }}</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1">{{ datosperiodoAnt.vacperiodo }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-card color="rgba(103, 164, 193, 0.14)">
                                        <v-card-text style="display: grid; place-items: center;">
                                            <div>
                                                <span>Días Tomados:</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1" style="font-size: medium; font-weight: bold;">{{
                                                    datosperiodoAnt.vactomados }}</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1">{{ datosperiodoAnt.vacperiodo }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-card color="rgba(103, 164, 193, 0.14)">
                                        <v-card-text style="display: grid; place-items: center;">
                                            <div>
                                                <span>Días por Autorizar:</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1" style="font-size: medium; font-weight: bold;">{{
                                                    datosperiodoAnt.vacporaut }}</span>
                                            </div>
                                            <div class="mt-3">
                                                <span class="mt-1">{{ datosperiodoAnt.vacperiodo }}</span>
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                </v-col>
                            </v-row>
                        </v-row>
                        <v-divider class="mt-8" v-if="mostrarperiodoant"></v-divider>
                        <v-row class="mt-4">
                            <span style="font-weight: bold;">Días periodo actual:</span>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" md="3">
                                <v-card>
                                    <v-card-text style="display: grid; place-items: center;">
                                        <div>
                                            <span style="font-weight: bold;">Días Totales:</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1" style="font-size: xx-large; font-weight: bold;">{{
                                                datos.vdias }}</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1">{{ datos.vacperiodo }}</span>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-card>
                                    <v-card-text style="display: grid; place-items: center;">
                                        <div>
                                            <span style="font-weight: bold;">Días Disponibles:</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1" style="font-size: xx-large; font-weight: bold;">{{
                                                datos.vacdisponibles }}</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1">{{ datos.vacperiodo }}</span>
                                        </div>
                                    </v-card-text>
                                </v-card>

                            </v-col>
                            <v-col cols="12" md="3">
                                <v-card>
                                    <v-card-text style="display: grid; place-items: center;">
                                        <div>
                                            <span style="font-weight: bold;">Días Tomados:</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1" style="font-size: xx-large; font-weight: bold;">{{
                                                datos.vactomados }}</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1">{{ datos.vacperiodo }}</span>
                                        </div>
                                    </v-card-text>
                                </v-card>

                            </v-col>
                            <v-col cols="12" md="3">
                                <v-card>
                                    <v-card-text style="display: grid; place-items: center;">
                                        <div>
                                            <span style="font-weight: bold;">Días por Autorizar:</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1" style="font-size: xx-large; font-weight: bold;">{{
                                                datos.vacporaut }}</span>
                                        </div>
                                        <div class="mt-4">
                                            <span class="mt-1">{{ datos.vacperiodo }}</span>
                                        </div>
                                    </v-card-text>
                                </v-card>

                            </v-col>
                        </v-row>
                        <v-divider class="mt-4"></v-divider>
                        <v-row class="mt-2">
                            <span style="font-weight: bold;">Selecciona días:</span>
                        </v-row>
                        <v-row class="mt-2">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="date" label="Selecciona los días deseados"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                        :required="valfecha" :error-messages="validacionfecha"
                                        :disabled="disdate"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" scrollable multiple
                                    @input="date.length <= maxDates ? date : date.splice(maxDates)" locale="es-mx"
                                    :min="datos.mindate" :event-color="getEventColor" :max="datos.maxdate"
                                    :events="datos.fechasVacAut.concat(datos.fechasVacPen)"
                                    :allowed-dates="isDateAllowed" color="primary"
                                    :selected-items-text="`${date.length} fechas seleccionadas`">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="error" @click="modal = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(date)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>


                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;" v-if="!cargandoDias">
                <v-row justify="center">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disabledSave"
                        @click="guardar()">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" title="Limpiar" @click="limpiar()" :disabled="disabledSave">
                        Limpiar
                    </v-btn>
                    <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disabledSave">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card class="mt-4" v-if="!showDetalle">
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">Historial Solicitudes</span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center" class="mt-2">
                    <v-col cols="12" md="11">
                        <v-row>
                            <v-col>
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :order="[]" @apiDT="apiDT = $event" :params="displayInputsListado">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-4" v-else>
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">Historial Solicitudes</span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="11">
                        <v-row>
                            <v-col>
                                <span class="mt-2"
                                    style="font-size: large; font-weight: bold; display: grid; place-items: center;">Detalle
                                    Solicitud</span>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-4"></v-divider>
                        <v-row class="mt-4">
                            <v-col>
                                <DataTable :url="urlDetalle" :columns="columnsDetalle" :order="[]"
                                    :params="displayInputs" @apiDT="apiDT = $event">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center">
                    <v-btn class="ma-2" color="error" title="Limpiar" @click="regresar()">
                        Regresar
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Vacaciones from "@/services/Vacaciones/Vacaciones.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState, mapGetters } from "vuex";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable
    },
    data() {
        return {
            modal: false,
            date: [],
            maxDates: 0,
            disabledSave: false,
            showDetalle: false,
            displayInputsListado: {
                uslogin: ''
            },
            urlListado: 'Vacaciones/HistorialSolicitudes',
            columns: [
                { name: 'vaeid', data: 'vaeid', title: 'No. Solicitud' },
                { name: 'vaefecalta', data: 'vaefecalta', title: 'Fecha Solicitud' },
                { name: 'vaeestatus', data: 'vaeestatus', title: 'Estatus' },
                { name: 'vaefecresponde', data: 'vaefecresponde', title: 'Fecha Respuesta' },
                { name: "", data: "vaeid", title: "Opciones", formatter: [this, "DetalleSolicitud"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "DetalleSol"] },
            ],
            apiDT: null,
            urlDetalle: 'Vacaciones/MostrarDiasDetalleSol',
            columnsDetalle: [
                { name: 'vaddia', data: 'vaddia', title: 'Fecha' },
                { name: 'diaSem', data: 'diaSem', title: 'Día Semana' },
                { name: 'vaeestatus', data: 'vaeestatus', title: 'Estatus' },
                { name: 'vacperiodo', data: 'vacperiodo', title: 'Periodo' },
                { name: 'vaeresponde', data: 'vaeresponde', title: 'Autoriza' },
                { name: 'fhresp', data: 'fhresp', title: 'Fecha respuesta' },
            ],
            displayInputs: {
                vaeid: 0,
            },
            datos: {
                usalta: null,
                vacdisponibles: null,
                vactomados: null,
                vdias: null,
                vacporaut: null,
                vacperiodo: null,
                mindate: null,
                maxdate: null,
                diasplazo: null,
                colorplazodias: "inherit",
                fechasVacAut: [],
                fechasVacPen: []
            },
            validacionfecha: "",
            valfecha: false,
            vacid: null,
            mostrarperiodoant: false,
            datosperiodoAnt: {
                vacdisponibles: null,
                vacid: null,
                vacperiodo: null,
                vacporaut: null,
                vactomados: null,
                vdias: null
            },
            disdate: true,
            cargandoDias: true,
            uslogin: null,
            usloginDesc: '',

        };
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
        ...mapGetters(['getUser']),
    },
    watch: {
        'date'(val) {
            if (val.length > 0) {
                this.validacionfecha = "";
                this.valfecha = false;
            }
        }
    },
    async mounted() {
        await this.ObtenerInfomarcion();
        this.cargandoDias = false;
        this.usloginDesc = this.getUser.get(this.permission.global).uslogin;
    },
    methods: {
        async ObtenerInfomarcion() {
            this.uslogin = await MetodosGenerales.ObtenerUserName()
            this.displayInputsListado = {
                uslogin: this.uslogin,
            };
            this.reloadTable();
            let respuesta = await Vacaciones.ActualizaNumeroDePeriodos(this.uslogin);
            if (respuesta.length > 0) {
                this.mostrarperiodoant = true;
                this.datosperiodoAnt = {
                    vacdisponibles: respuesta[0].vacdisponibles,
                    vacid: respuesta[0].vacid,
                    vacperiodo: respuesta[0].vacperiodo,
                    vacporaut: respuesta[0].vacporaut,
                    vactomados: respuesta[0].vactomados,
                    vdias: respuesta[0].vdias
                }
            }
            let response = await Vacaciones.ObtenerFechas(this.uslogin);
            this.datos.fechaIngreso = response.usalta;
            let dias = await Vacaciones.ObtenerDiasVacaciones(this.uslogin);

            this.vacid = dias.vacid;
            this.datos = {
                usalta: response.usalta,
                vacdisponibles: dias.vacdisponibles,
                vactomados: dias.vactomados,
                vdias: dias.vdias,
                vacporaut: dias.vacporaut,
                vacperiodo: dias.vacperiodo,
                mindate: response.mindate,
                maxdate: response.maxdate,
                diasplazo: response.diasplazo,
                colorplazodias: response.colorplazodias,
                fechasVacAut: response.fechasVacAut.length > 1 ? response.fechasVacAut.split(', ') : [],
                fechasVacPen: response.fechasVacPen.length > 1 ? response.fechasVacPen.split(', ') : []
            }
            this.maxDates = dias.diasPermitidos;
            this.disdate = this.datos.vacdisponibles == 0 ? true : false
        },
        DetalleSolicitud(datos) {
            return datos.vaeid ? `<div><button type="button" class="mx-2 v-btn v-btn--is-elevated v-btn--has-bg  theme--dark v-size--small primary dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.vaeid}" title="Ver detalle" aria-expanded="false"><span class="v-btn__content">Detalles</span></button></div>` : ``;
        },
        DetalleSol(params, datos, fila) {
            this.showDetalle = true;
            this.displayInputs = {
                vaeid: datos.vaeid
            };
            this.reloadTable();
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        regresar() {
            this.showDetalle = false;
        },
        addDate(newDate) {
            if (this.date.length < this.maxDates) {
                this.date.push(newDate);
            }
        },
        limpiar() {
            this.date = [];
            this.validacionfecha = "";
            this.valfecha = false;
        },
        cancelar() {
            this.$router.push({ name: "index" });
        },
        getEventColor(date) {
            if (this.datos.fechasVacAut.includes(date)) return 'green';
            if (this.datos.fechasVacPen.includes(date)) return 'grey';
            return null;
        },
        isDateAllowed(date) {
            return !this.datos.fechasVacAut.concat(this.datos.fechasVacPen).includes(date)
        },
        async guardar() {
            this.disabledSave = true;
            if (this.date.length === 0) {
                this.disabledSave = false;
                this.validacionfecha = "El campo es requerido";
                this.valfecha = true;
            } else {
                this.date.sort((a, b) => {
                    return a.localeCompare(b);
                });

                this.$swal({
                    title: 'Guardando solicitud, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await Vacaciones.GuardarSolicitud(this.vacid, this.date.join(), this.uslogin);
                        if (response.msg == 'Ok') {
                            let mensaje = this.usloginDesc == "marsuaga" ? 'Solicitud enviada y respondida correctamente.' : 'Solicitud enviada correctamente, pronto será respondida.';
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: mensaje,
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.ObtenerInfomarcion();
                                this.reloadTable();
                                this.limpiar();
                                this.disabledSave = false;
                            });
                        } else if (response.msg == 'Correo') {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'El correo de notificación no ha sido enviado correctamente.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                            this.disabledSave = false;
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al guardar la solicitud de vacaciones, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                            this.disabledSave = false;
                        }

                    }
                })
            }
        },
    }
}
</script>

<style>
.plazodias {
    text-align: end;
}

@media screen and (max-width: 959px) {
    .plazodias {
        text-align: start;
    }
}
</style>